/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { Description } from "../../atoms/description";
import { QUILL_EMPTY_STRING } from "../../../../../constants";
import "./minimalist.m.css";

export const DataBlock = ({ mode, subscriptionConfig, group }) => {
  const { description } = group;
  const { pageTitle = "", pageDescription = "", descriptionTitle } = subscriptionConfig;
  const updatedPageTitle = pageTitle === QUILL_EMPTY_STRING ? "" : pageTitle;
  const updatedPageDescription = pageDescription === QUILL_EMPTY_STRING ? "" : pageDescription;
  const space = updatedPageDescription ? "space" : "";
  return (
    <div styleName={`container ${mode}`}>
      {(updatedPageDescription || updatedPageTitle) && (
        <div>
          {updatedPageTitle && (
            <h1
              styleName={`page-title ${space}`}
              data-test-id="page-title"
              dangerouslySetInnerHTML={{ __html: pageTitle }}
            />
          )}
          {updatedPageDescription && (
            <div
              styleName="page-description"
              data-test-id="page-description"
              dangerouslySetInnerHTML={{ __html: pageDescription }}
            />
          )}
        </div>
      )}
      <Description
        data={description}
        descriptionTitle={descriptionTitle}
        mode={mode}
        displayDescription={true}
        type="group"
      />
    </div>
  );
};
